module.exports = __webpack_public_path__ + "img/full3-min.e2a89e69.png";